import { ApiError } from '../../../adapters/api-client/api';

/**
 * Why the server refused a learner's join (backend: session.service.ts
 * `JOIN_REFUSAL_CODES`). The server decides on its own clock and the governed
 * window; the room only names the answer it got, in words a child can read.
 */
export type JoinRefusalCode =
  | 'JOIN_WINDOW_NOT_OPEN'
  | 'JOIN_WINDOW_CLOSED'
  | 'SESSION_CANCELLED'
  | 'ENROLLMENT_NOT_ACTIVE'
  | 'WAITING_FOR_TEACHER'
  | 'RECORDING_CONSENT_REQUIRED'
  | 'IDENTITY_CHECK_REQUIRED';

export const JOIN_REFUSAL_COPY: Record<JoinRefusalCode, string> = {
  JOIN_WINDOW_NOT_OPEN: 'Todavía no es la hora de entrar a esta clase.',
  JOIN_WINDOW_CLOSED: 'Esta clase ya terminó.',
  SESSION_CANCELLED: 'Esta clase se canceló.',
  ENROLLMENT_NOT_ACTIVE: 'Esta clase no está disponible ahora. Pide ayuda a un adulto.',
  WAITING_FOR_TEACHER: 'Tu profesor todavía no ha abierto la clase.',
  // DEC-S3-S08-08: the guardian's consent, not the child's. Nothing to fix here.
  RECORDING_CONSENT_REQUIRED:
    'Esta clase no se puede abrir: falta el permiso de grabación de la familia. Pide ayuda a un adulto.',
  // DEC-S3-T09-07 / S08-07: the guardian-assisted path. Off until a method exists.
  IDENTITY_CHECK_REQUIRED:
    'No pudimos dejarte entrar a esta clase. Pide a un adulto que hable con soporte o cambie la clase de día.',
};

/** The typed refusal in an error from `GET /sessions/:bookingId/join`, if it is one. */
export function joinRefusalOf(error: unknown): JoinRefusalCode | undefined {
  if (!(error instanceof ApiError)) return undefined;
  const code = error.body?.code;
  return typeof code === 'string' && code in JOIN_REFUSAL_COPY
    ? (code as JoinRefusalCode)
    : undefined;
}

/** A refusal that a short wait can turn into an entry; the room keeps checking. */
export const isWaitingRefusal = (code: JoinRefusalCode | undefined): boolean =>
  code === 'WAITING_FOR_TEACHER';
